import axios from 'axios';
import React, { useEffect, useState } from 'react'

const Faqs = () => {

    const [openIndex, setOpenIndex] = useState(null);

    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const [faqs, setFaqs] = useState([]);

    useEffect(() => {
        const fetchFAQs = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/jobs/getfaqs`); // Replace with your API endpoint
                setFaqs(response.data);
            } catch (error) {
                console.error('Error fetching FAQs:', error);
            }
        };
    
        fetchFAQs();
    }, []);

    
    return (
        <div className='px-16 pt-16 flex flex-col gap-20 min-h-[130vh]'>

            <div className='flex justify-between gap-10 items-end'>
                <div className='font-semibold text-4xl'>
                    <div className=''>You've got questions,</div>
                    <div className='mt-2 text-[var(--primary)]'>We've got answers!</div>
                </div>

                <button className='button white'>
                    Contact Us
                </button>

            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                <div className="flex flex-col gap-6">
                    {faqs.slice(0, 4).map((faq, index) => (

                        <div key={index} className="bg-white p-6 text-sm rounded-2xl shadow-sm border border-gray-200 cursor-pointer" onClick={() => toggleAccordion(index)}>
                            <div className="font-semibold flex justify-between items-center gap-2 min-h-[40px] my-auto">
                                {faq.question}
                                <span className="text-lg font-light transition-transform duration-150" style={{ transform: openIndex === index ? 'rotate(45deg)' : 'rotate(0)' }}>
                                    +
                                </span>
                            </div>
                            <div
                                className={`overflow-hidden transition-all duration-150 ease-in-out
                                    ${openIndex === index ? "max-h-[999px] mt-6 h-auto" : "max-h-0"}`}
                            >
                                {faq.answer}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="flex flex-col gap-6">
                    {faqs.slice(4).map((faq, index) => (

                        <div key={index} className="bg-white p-6 text-sm rounded-2xl shadow-sm border border-gray-200 cursor-pointer" onClick={() => toggleAccordion(index + 4)}>
                            <div className="font-semibold flex justify-between items-center gap-2 min-h-[40px] my-auto">
                                {faq.question}
                                <span className="text-lg font-light transition-transform duration-150" style={{ transform: openIndex === index + 4 ? 'rotate(45deg)' : 'rotate(0)' }}>
                                    +
                                </span>
                            </div>
                            <div
                                className={`overflow-hidden transition-all duration-150 ease-in-out
                                    ${openIndex === index + 4 ? "max-h-[999px] mt-6 h-auto" : "max-h-0"}`}
                            >
                                {faq.answer}
                            </div>
                        </div>
                    ))}
                </div>

            </div>

        </div>
    )
}

export default Faqs

// const faqs = [
//     {
//         question: "What makes Hunt High Careers different from job portals or traditional recruitment platforms?",
//         answer: "Hunt High for Careers is not a job board,we are your strategic hiring partner. Our process goes beyond automated listings, using human insight, emotional intelligence screening, and performance-based shortlisting to connect you with the right talent. Every candidate is manually screened, competency-assessed, and mapped to industry-specific talent pools, ensuring only the most relevant, high-quality professionals reach your team."
//     },
//     {
//         question: "How do you select candidates for our company?",
//         answer: "Our process begins by understanding your business DNA i.e your culture, goals, and the kind of people who drive your vision forward. Candidates are then curated from exclusive talent pools and filtered.We evaluate: ● Capability Fit (Technical & Functional Skills) ● Culture Compatibility (Values, Mindset & Team Dynamics) ● Potential for Performance (Long-Term Growth & Impact) Only those who align with all three layers make it to your shortlist"
//     },
//     {
//         question: "Do you offer replacement guarantees if a hire doesn't work out?",
//         answer: "Yes. If a candidate placed by HH for Careers does not meet the agreed-upon KPIs within 30 days..."
//     },
//     {
//         question: "How long does the hiring process typically take?",
//         answer: "We ensure that most roles are filled within 4–6 weeks..."
//     },
//     {
//         question: "What kind of companies does Hunt High Careers partner with?",
//         answer: "We work with small to mid-sized businesses and startups..."
//     },
//     {
//         question: "How can I apply for job opportunities through Hunt High Careers?",
//         answer: "To apply, browse our curated job opportunities on our website..."
//     },
//     {
//         question: "Does Hunt High Careers charge candidates for job placements?",
//         answer: "No, we do not charge candidates. Our focus is on matching talent with the right companies..."
//     },
//     {
//         question: "How does Hunt High for Careers support candidates throughout the hiring journey?",
//         answer: "At Hunt High for Careers, we don't just place candidates, we invest in them..."
//     }
// ];
